import React from 'react';

const PageContainer = props => (
    <div className={"PageContainer"}>
        {props.children}
    </div>
);

export default PageContainer;